export function computeAverage (playerCounts) {
  const valid = playerCounts.filter(v => v !== null && typeof v === 'number')
  if (valid.length === 0) return 0
  return valid.reduce((sum, v) => sum + v, 0) / valid.length
}
